import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AuthService } from 'src/app/auth/auth.service';
import { FocusOrigin } from '@angular/cdk/a11y';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { State } from 'src/app/store/state';
import { UserManagementDialogComponent } from '../user-management-dialog/user-management-dialog.component';
import { SharedService } from '../../services/shared.service';
import { Profile } from '../../models/auth/profile';
import { Role } from '../../models/auth/role';
import { Menu, orgType } from '../../../config/app-constants';
import { AppComponent } from 'src/app/app.component';
import { PermissionGroupsDialogComponent } from '../permission-groups-dialog/permission-groups-dialog.component';
import { SystemAlertsDialogComponent } from 'src/app/internal-user/notifications/components/system-alerts-dialog/system-alerts-dialog.component';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit {
  @Output() menuClick: EventEmitter<void> = new EventEmitter<void>();
  @Output() cdkFocusChange: EventEmitter<FocusOrigin> = new EventEmitter<FocusOrigin>();
  @Input() enablePharmacyPeek: boolean;

  profile: Profile;
  message: string;
  enableGearIcon = false;
  enableGearIconUserManagement = false;
  enableGearIconPermissionGroup = false;
  enableNotificationsIcon = false;

  Role = Role;

  constructor(
    public auth: AuthService,
    public dialog: MatDialog,
    private messageService: SharedService,
    public myapp: AppComponent,
    public store: Store<State>,
  ) { }

  ngOnInit() {
    this.messageService.sharedMessage
      .subscribe(message => this.message = message);
    this.auth.profile$.subscribe(profile => {
      this.profile = profile;
      this.enableGearIcon = profile.menuPermissions.includes(Menu.GearIconUserManagement) ||  profile.menuPermissions.includes(Menu.GearIconPermissionGroup);
      this.enableGearIconUserManagement = profile.menuPermissions.includes(Menu.GearIconUserManagement);
      this.enableGearIconPermissionGroup = profile.menuPermissions.includes(Menu.GearIconPermissionGroup);
      this.enableNotificationsIcon = profile.hasSystemAlertingAccess();
    });
  }

  openUserManagement() {
    if (this.auth.loggedIn && this.enableGearIconUserManagement) {
      this.dialog.open(
        UserManagementDialogComponent,
        { disableClose: true, backdropClass: ['usermgmtDialog','lgDialog', 'SnackDialog'] },
      );
    }
  }

  openPermissionGroups() {
    if (this.auth.loggedIn && this.enableGearIconPermissionGroup) {
      this.dialog.open(
        PermissionGroupsDialogComponent,
        { disableClose: true, backdropClass: ['PermissionGrpsDialog','lgDialog', 'SnackDialog'] },
      );
    }
  }

  openPharmacyPeekDialog() {
    this.myapp.openPharmacyPeekDialog();
    return;
  }

  onClickNotifications() 
  {
    if (this.auth.loggedIn && this.enableNotificationsIcon) {
      this.dialog.open(
        SystemAlertsDialogComponent,
        { disableClose: false, backdropClass: ['notificationsDialog','lgDialog', 'SnackDialog'] },
      );
    }
  }
}
